import { ListItem, ListItemText, ListItemIcon } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

import { LearningActivityStatus, STATUSES, ACTIVITY_TYPE } from '../../../learning-activities';

const styles = /* istanbul ignore next */ ({ spacing }) => ({
  root: {
    padding: 0,
    '& + &': {
      paddingTop: spacing(3),
    },
  },
  withSmallIcon: {
    minWidth: 40,
  },
});

export const LearningOutcomeListItem = ({
  title,
  classes = {},
  hasSmallIcon = false,
  status = STATUSES.STATUS_NOT_STARTED,
}) => (
  <ListItem className={classes.root}>
    <ListItemIcon classes={{ root: hasSmallIcon ? classes.withSmallIcon : null }}>
      <LearningActivityStatus
        isBig={!hasSmallIcon}
        status={status}
        activityType={ACTIVITY_TYPE.LEARNING_OUTCOME}
      />
    </ListItemIcon>
    <ListItemText primary={title} />
  </ListItem>
);

export default withStyles(styles)(LearningOutcomeListItem);
